// What became of a "keep mine" in the held-back list (#693). Choosing only puts
// the device's version in the queue (conflicts.ts sendMineAnyway); CRM hasn't
// taken it until the outbox says so. So the list reads the record as stored,
// and its queue entry, and never says "sent" before it is. Pure.
import type { DeviceRecord } from './device-store';

export type SendOutcome =
  /** Queued, no answer yet. */
  | { kind: 'sending' }
  /** The last try failed (a server fault, a lost reply): sync tries it again by itself. */
  | { kind: 'retrying'; error: string }
  /** CRM took it: the device's copy is CRM's now. */
  | { kind: 'sent' }
  /** Someone changed it in CRM again before it went: back in the list to choose again. */
  | { kind: 'held' }
  /** CRM refused it: set aside on the sync bar with its reason (refused.ts). */
  | { kind: 'refused'; reason: string }
  /** No longer on this device (removed from elsewhere meanwhile). */
  | { kind: 'gone' };

/** `queueError`: the last error on the record's queue entry, if it has one and a try has failed. */
export function sendOutcome(record: DeviceRecord | undefined, queueError: string | null): SendOutcome {
  if (!record) return { kind: 'gone' };
  if (record.refusedReason) return { kind: 'refused', reason: record.refusedReason };
  if (record.state === 'conflict') return { kind: 'held' };
  if (record.state === 'synced') return { kind: 'sent' };
  return queueError ? { kind: 'retrying', error: queueError } : { kind: 'sending' };
}
